/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * RAQT Admin API
 * API documentation for RAQT admin applications. Restricted access.
 * OpenAPI spec version: 1.0
 */

/**
 * Currency code (ISO 4217)
 */
export type CurrencyEnum = typeof CurrencyEnum[keyof typeof CurrencyEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CurrencyEnum = {
  aed: 'aed',
  afn: 'afn',
  all: 'all',
  amd: 'amd',
  ang: 'ang',
  aoa: 'aoa',
  ars: 'ars',
  aud: 'aud',
  awg: 'awg',
  azn: 'azn',
  bam: 'bam',
  bbd: 'bbd',
  bdt: 'bdt',
  bgn: 'bgn',
  bif: 'bif',
  bmd: 'bmd',
  bnd: 'bnd',
  bob: 'bob',
  brl: 'brl',
  bsd: 'bsd',
  bwp: 'bwp',
  byn: 'byn',
  bzd: 'bzd',
  cad: 'cad',
  cdf: 'cdf',
  chf: 'chf',
  clp: 'clp',
  cny: 'cny',
  cop: 'cop',
  crc: 'crc',
  cve: 'cve',
  czk: 'czk',
  djf: 'djf',
  dkk: 'dkk',
  dop: 'dop',
  dzd: 'dzd',
  egp: 'egp',
  etb: 'etb',
  eur: 'eur',
  fjd: 'fjd',
  fkp: 'fkp',
  gbp: 'gbp',
  gel: 'gel',
  gip: 'gip',
  gmd: 'gmd',
  gnf: 'gnf',
  gtq: 'gtq',
  gyd: 'gyd',
  hkd: 'hkd',
  hnl: 'hnl',
  htg: 'htg',
  huf: 'huf',
  idr: 'idr',
  ils: 'ils',
  inr: 'inr',
  isk: 'isk',
  jmd: 'jmd',
  jpy: 'jpy',
  kes: 'kes',
  kgs: 'kgs',
  khr: 'khr',
  kmf: 'kmf',
  krw: 'krw',
  kyd: 'kyd',
  kzt: 'kzt',
  lak: 'lak',
  lbp: 'lbp',
  lkr: 'lkr',
  lrd: 'lrd',
  lsl: 'lsl',
  mad: 'mad',
  mdl: 'mdl',
  mga: 'mga',
  mkd: 'mkd',
  mmk: 'mmk',
  mnt: 'mnt',
  mop: 'mop',
  mur: 'mur',
  mvr: 'mvr',
  mwk: 'mwk',
  mxn: 'mxn',
  myr: 'myr',
  mzn: 'mzn',
  nad: 'nad',
  ngn: 'ngn',
  nio: 'nio',
  nok: 'nok',
  npr: 'npr',
  nzd: 'nzd',
  pab: 'pab',
  pen: 'pen',
  pgk: 'pgk',
  php: 'php',
  pkr: 'pkr',
  pln: 'pln',
  pyg: 'pyg',
  qar: 'qar',
  ron: 'ron',
  rsd: 'rsd',
  rub: 'rub',
  rwf: 'rwf',
  sar: 'sar',
  sbd: 'sbd',
  scr: 'scr',
  sek: 'sek',
  sgd: 'sgd',
  shp: 'shp',
  sle: 'sle',
  sos: 'sos',
  srd: 'srd',
  std: 'std',
  szl: 'szl',
  thb: 'thb',
  tjs: 'tjs',
  top: 'top',
  try: 'try',
  ttd: 'ttd',
  twd: 'twd',
  tzs: 'tzs',
  uah: 'uah',
  ugx: 'ugx',
  usd: 'usd',
  uyu: 'uyu',
  uzs: 'uzs',
  vnd: 'vnd',
  vuv: 'vuv',
  wst: 'wst',
  xaf: 'xaf',
  xcd: 'xcd',
  xof: 'xof',
  xpf: 'xpf',
  yer: 'yer',
  zar: 'zar',
  zmw: 'zmw',
} as const;
